import { isChrome, isFirefox, isIOS, isMobileSafari, isSafari } from 'react-device-detect';
import isMobileOS from 'utils/browser-util';
import getInitialState from './initialState';

export default {
  setApplication: (state, settings) => Object.assign(state, settings),

  setKwtMode: (state, kwtMode) => Object.assign(state, { kwtMode }),

  determineDeviceCapabilities: state => {
    return Object.assign(state, {
      device: {
        ...state.device,
        isChrome: isChrome || navigator.userAgent.toLowerCase().includes('crios'),
        isIOSApp: isIOS && isMobileSafari && !isChrome && !isFirefox && !isSafari,
        isMobile: isMobileOS()
      }
    });
  },

  setToolbarMode: (state, mode) => Object.assign(state, { toolbarMode: mode }),

  chooseMobileKeyboard: (state, choice) =>
    Object.assign(state, {
      device: { ...state.device, usingExternalKeyboard: choice }
    }),

  setModal: (state, modal) => Object.assign(state, { modal }),

  setVideoAndIsVideoPathAbsolute: (state, { video, isVideoPathAbsolute }) =>
    Object.assign(state, { video, isVideoPathAbsolute }),

  resetApplication: state => Object.assign(state, { ...getInitialState() }),

  setLiteVersion: (state, liteVersion) => Object.assign(state, { isLiteVersion: liteVersion }),

  setAccessibilityMode: (state, isAccessibilityModeOn) =>
    Object.assign(state, { accessibilityMode: isAccessibilityModeOn })
};
